import { render, staticRenderFns } from "./noshipsop.vue?vue&type=template&id=254c197e&scoped=true"
import script from "./noshipsop.vue?vue&type=script&lang=js"
export * from "./noshipsop.vue?vue&type=script&lang=js"
import style0 from "./noshipsop.vue?vue&type=style&index=0&id=254c197e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c197e",
  null
  
)

export default component.exports